// React
import React from 'react';

// MUI
import { Box, Typography, Grid, Button } from '@mui/material';

// Interfaces

// Libs
import i18n from '../i18n';

// Utils
import { getStorageLinks } from '../utils/util';
import DeviceBreakPoints from '../configurations/deviceBreakpoints';
var SuccessPage = function SuccessPage(props) {
  var closeModal = function closeModal() {
    props === null || props === void 0 || props.setOpenRegisterModal(false);
    props === null || props === void 0 || props.cancelHandler();
  };
  var _DeviceBreakPoints = DeviceBreakPoints(),
    isSmallDevice = _DeviceBreakPoints.isSmallDevice;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    sx: {
      backgroundColor: 'secondary.main',
      display: 'flex',
      alignItems: 'center',
      padding: '0 2rem',
      minHeight: isSmallDevice ? '100%' : '30rem'
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    sx: {
      flexDirection: 'column',
      textAlign: 'center'
    },
    spacing: 4
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(Box, {
    sx: {
      width: '100px'
    },
    component: "img",
    src: getStorageLinks(props.environment).cdn + '/assets/img/success-tick.svg'
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    component: "h6"
  }, i18n.t('REGISTRATION.SUCCESS_MESSAGE_HEADING')), /*#__PURE__*/React.createElement(Typography, {
    component: "p",
    sx: {
      fontSize: '0.8rem'
    }
  }, i18n.t('REGISTRATION.SUCCESS_MESSAGE_DESCRIPTION_1')), /*#__PURE__*/React.createElement(Typography, {
    component: "p",
    sx: {
      fontSize: '0.8rem'
    }
  }, i18n.t('REGISTRATION.SUCCESS_MESSAGE_DESCRIPTION_2'))), /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(Button, {
    sx: {
      width: '160px',
      padding: '10px'
    },
    variant: "contained",
    color: "primary",
    onClick: function onClick() {
      return closeModal();
    }
  }, i18n.t('REGISTRATION.OKAY'))))));
};
export default SuccessPage;